import { CanActivateFn, Router } from '@angular/router';
import { CartDataService, HREF, ProductCapabilitiesService, CartRelationshipService } from '@core';
import { inject } from '@angular/core';
import { map, switchMap } from 'rxjs';

export const checkoutGuard: CanActivateFn = () => {
  const cartDataService = inject(CartDataService);
  const router = inject(Router);
  const capabilitiesService = inject(ProductCapabilitiesService);
  const cartRelationshipService = inject(CartRelationshipService);

  return cartDataService.fetchProductCart().pipe(
    switchMap((data) => {
      if (!data || !data.products || data.products.length === 0) {
        return [router.createUrlTree([HREF.CART])];
      }

      const allAvailable = data.products.every((product) => product.isAvailable);
      if (!allAvailable) {
        return [router.createUrlTree([HREF.HOME])];
      }

      // Validate AppleCare items have valid relatedLineNumber
      return capabilitiesService.getAppleCareProductIds().pipe(
        map((appleCareProductIds) => {
          const validation = cartRelationshipService.validateAppleCareRelatedLineNumbers(data, appleCareProductIds);

          if (!validation.isValid) {
            // Redirect to cart - the cart component will validate and show error on load
            return router.createUrlTree([HREF.CART]);
          }

          return true;
        }),
      );
    }),
  );
};
